import http from '@/utils/request'


/**
 * 账号相关接口
 */

// 用户登录
export const login = (params) => http.post('/user/login',params)

// 获取用户权限
export const getUserPermissions = () => http.get('manager/stbhq/permissions')
